export enum ReferralUrgency {    
    Unknown = 0,
    Immediate = 1,
    Soon = 2,
    FutureConcern = 3
}